import o from"./index.module.scss.js";const s=o;export{s as ModalTheme};
//# sourceMappingURL=index.js.map
